import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Flat} from '../../models/flat.model';
import * as _ from 'underscore';
import {FlatManagerService} from '../../service/flat-manager.service';


@Component({
  selector: 'app-flat-map-section',
  templateUrl: './flat-map-section.component.html',
  styleUrls: ['./flat-map-section.component.scss']
})
export class FlatMapSectionComponent implements OnInit {

  @Input() selectorMode: boolean;
  @Input() smallHeader: boolean;
  @Input() selectedFlat: Flat;
  @Input() highlightedFlat: Flat;
  @Output() pointSelected = new EventEmitter();

  flatsByLevel: object = {
    0: [],
    1: [],
    2: []
  };

  activeLevel = 0;
  allFlat: Flat[] = [];
  flatsLoading = true;
  buildingLevels: BuildingLevel[] = [
    {label: 'Pinceszint', level: 0},
    {label: 'Földszint', level: 1},
    {label: '1. emelet', level: 2}

  ];

  constructor(private flatManagerService: FlatManagerService) {


  }

  ngOnInit() {

    if (this.highlightedFlat) {
      this.activeLevel = this.highlightedFlat.level;
    }

    if (!this.selectorMode) {
      this.flatManagerService.getFlatsAndSave();

      this.flatManagerService.flats.subscribe((flats) => {

        if (flats && flats.items && flats.items.length) {
          this.allFlat = flats.items;
          this.initFlatsByLevel();
          this.flatsLoading = false;
        }
      });
    } else {
      this.flatsLoading = false;
    }

    //
    // if (!this.selectorMode) {
    //   this.allFlat = TestFlats.getAllFlat();
    //   this.initFlatsByLevel();
    // }

  }

  onPointSelected(event) {
    this.pointSelected.emit({...event, level: this.activeLevel});
  }

  initFlatsByLevel() {


    _.forEach(this.allFlat, (flat: Flat) => {
      if (flat.latitude && flat.longitude) {
        this.flatsByLevel[flat.level].push(flat);
      }
    });

  }

}

export interface BuildingLevel {
  label: string;
  level: number;
}

